{% block sw_extension_listing_card %}
    <div class="sw-extension-listing-card" @click="openDetailPage">
        {% block sw_extension_listing_card_content %}
            {% block sw_extension_listing_card_info_grid %}
                <div class="sw-extension-listing-card__info-grid">
                    {% block sw_extension_listing_card_info_icon %}
                        <sw-extension-icon
                            class="sw-extension-listing-card__info-icon"
                            :src="extension.icon"
                        />
                    {% endblock %}

                    {% block sw_extension_listing_card_info_name %}
                        <p class="sw-extension-listing-card__info-name">
                            {{ extension.label }}
                        </p>
                    {% endblock %}

                    {% block sw_extension_listing_card_info_rating %}
                        <div class="sw-extension-listing-card__info-rating">
                            <sw-extension-rating-stars
                                class="sw-extension-listing-card__info-rating-stars"
                                :rating="extension.rating"
                                :size="12"
                            />

                            <span class="sw-extension-listing-card__info-rating-count">
                                {{ extension.numberOfRatings }}
                            </span>
                        </div>
                    {% endblock %}

                    {% block sw_extension_listing_card_label_display %}
                        <sw-extension-store-label-display
                            v-if="extension.labels.length > 0"
                            :labels="extension.labels"
                            class="sw-extension-listing-card__label-display"
                        />
                    {% endblock %}

                    {% block sw_extension_listing_card_info_description %}
                        <p class="sw-extension-listing-card__info-description is--wrap-content">
                            {{ extension.shortDescription }}
                        </p>
                    {% endblock %}

                    {% block sw_extension_listing_card_info_price %}
                        <div class="sw-extension-listing-card__info-price">
                            <template v-if="isInstalled">
                                <strong>{{ $t('sw-extension-store.component.sw-extension-listing-card.labelInstalled') }}</strong>
                            </template>

                            <template v-else-if="isLicensed">
                                <strong>{{ $t('sw-extension-store.component.sw-extension-listing-card.labelLicensed') }}</strong>
                            </template>

                            <template v-else-if="isFree">
                                <strong>{{ $t('sw-extension-store.general.labelFree') }}</strong>
                            </template>

                            <template v-else-if="recommendedVariant">
                                <span
                                    v-if="hasActiveDiscount"
                                    class="sw-extension-listing-card__info-price-badge-sale"
                                >
                                    {{ $t('sw-extension-store.general.labelSale') }}
                                </span>

                                <i18n-t :keypath="calculatedPriceSnippet" tag="span" :class="priceClass">
                                    <template #price>
                                        <strong>{{ calculatedPrice }}</strong>
                                    </template>
                                </i18n-t>
                            </template>
                        </div>
                    {% endblock %}
                </div>
            {% endblock %}
        {% endblock %}
    </div>
{% endblock %}
